<template>
  <div>
    <label class="block text-sm font-medium text-gray-700">{{ label }} <span v-if="required" class="text-red-500">*</span>
      <select
          class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
          :class="generateClass"
          id="origen" :value="value" v-on:input="$emit('input', $event.target.value)"
          v-on:change="$emit('change', $event.target.value)" :disabled="disabled">
        <option :value="null" v-if="showPlaceHolder">{{ placeholder }}</option>
        <option v-for="(item,index) in options" :value="getValue(item, namevalue)" :key="index">
          {{ getValue(item, nametext) }}
        </option>
      </select>
      <span class="flex items-center font-medium tracking-wide text-xs mt-1 ml-1"
            :class="state===true?'text-green-500':'text-red-500'"
            v-if="state!==null">
			          {{ state === true ? validMessage : errorMessage }}
		        </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "selectcomponent",
  props: {
    value: null,
    options: {
      type: Array,
      default: []
    },
    nametext: {
      type: String,
      default: 'text'
    },
    namevalue: {
      type: String,
      default: 'value'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Seleccionar'
    },
    showPlaceHolder: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: 'No valido'
    },
    validMessage: {
      type: String,
      default: 'Valido'
    },
    state: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getValue(element, propiedad) {
      return element[propiedad]
    },
  },
  computed: {
    generateClass() {
      let classes = ""
      classes += this.state === false ? 'border-red-500' : this.state === true ? 'border-green-500' : 'focus:border-gray-200'
      classes += this.disabled ? ' bg-gray-100' : ''
      return classes
    }
  },
  watch: {
    options() {
      let aux = this.value
      if (aux !== null){
        this.$emit('input', null)
        setTimeout(() => {
          this.$emit('input', aux)
        }, 1)
      }
    }
  }
}
</script>

<style scoped>

</style>
